export default {
      id: "viroflay_fr-usage",
      viewBox: "0 0 144 20",
      url: "../dist/images/" + "sprite.svg#viroflay_fr-usage",
      toString: function () {
        return this.url;
      }
    }